var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "accordion-block"
  }, [_c('h2', {
    staticClass: "accordion-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "accordion"
  }, _vm._l(_vm.content, function (item, accordionIndex) {
    return _c('div', {
      key: item.title,
      staticClass: "acc-item",
      class: {
        'acc-item--expanded': _vm.expandedStatus[accordionIndex]
      }
    }, [_c('div', {
      staticClass: "acc-header",
      on: {
        "click": function click($event) {
          return _vm.toggleAccordion(accordionIndex);
        }
      }
    }, [_c('span', {
      staticClass: "acc-title"
    }, [_vm._v(_vm._s(item.title))]), _c('span', {
      staticClass: "acc-actions"
    }, [_c('svg', {
      staticClass: "acc-chevron",
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "d": "M6 9l6 6 6-6",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    })])])]), _c('div', {
      staticClass: "acc-panel"
    }, [_c('ul', {
      staticClass: "test-list"
    }, _vm._l(item.items, function (test) {
      return _c('li', {
        key: test.name,
        staticClass: "test-row"
      }, [_c('div', [_c('div', {
        staticClass: "test-name"
      }, [_vm._v(_vm._s(test.name))]), _c('div', {
        staticClass: "test-desc"
      }, [_vm._v(_vm._s(test.description))])])]);
    }), 0)])]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }